<template lang="pug">
    BaseTabs2.b-affiliate-tabs(:items="$options.tabs" :value="tab || $route.name" @input="$router.push({ name: $event })")
</template>

<script>
import BaseTabs2 from '@/components/BaseTabs2.vue';

export default {
  name: 'AffiliateTabs',
  components: { BaseTabs2 },
  props: { tab: String },
  tabs: [
    { name: 'affiliate-main',         label: 'Главная'  }, // eslint-disable-line
    { name: 'affiliate-referrals',    label: 'Рефералы' }, // eslint-disable-line
    { name: 'affiliate-transactions', label: 'История'  }, // eslint-disable-line
    { name: 'affiliate-payouts',      label: 'Выплаты'  }, // eslint-disable-line
    { name: 'affiliate-rules',        label: 'Правила'  }, // eslint-disable-line
  ],
};
</script>

<style scoped>

</style>
